import YoutubeControl from '../youtube/youtube-control';

const SELECTOR = '[data-ytid]';

jQuery(function($) {
    var loading = false;

    function loadMoreContent() {
        if (loading === false && gs_together_loadmore_params.current_page < gs_together_loadmore_params.max_page) {
            loading = true;

            var data = {
                'action': 'loadmore',
                'query': gs_together_loadmore_params.posts,
                'page': gs_together_loadmore_params.current_page,
            };

            if (window.post_type === 'casestudies') {
                data['customFilter'] = {
                    'project_type': window.projectTypeFilter,
                    'project_size': window.projectSizeFilter,
                    'workflow': window.workflowFilter,
                    'software_used': window.softwareUsedFilter,
                    'location': window.locationFilter,
                    'firm_type': window.firmTypeFilter,
                };
            }

            $.ajax({
                url: GS.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function(xhr) {
                    if ($('.loadmore-btn').length) {
                        var button = $('.loadmore-btn');
                        button.originalText = button.text();
                        button.text(gs_together_loadmore_params.loadText);
                    } else {
                        $('#content').append('<div class="loading-text">' + gs_together_loadmore_params.loadText + '</div>');
                    }
                },
                success: function(data) {
                    $('.loading-text').remove();

                    if (data) {
                        $('#content').find('.loadmore > article:last').after(data);
                        gs_together_loadmore_params.current_page++;

                        new YoutubeControl({}).init(SELECTOR).then((players) => {
                            console.log('youtube control', players);
                        });

                        if (gs_together_loadmore_params.current_page == gs_together_loadmore_params.max_page) {
                            $('.loadmore-btn').remove();
                            $(window).off('scroll');
                        }
                    } else {
                        $('.loadmore-btn').remove();
                    }

                    loading = false;
                },
                error: function() {
                    $('.loading-text').remove();
                    loading = false;
                }
            });
        }
    }

    $('.loadmore-btn').on('click', function() {
        loadMoreContent();
    });

    if ($('#gs-casestudies-page').length > 0) {
        $(window).on('scroll', function() {
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 600) {
                loadMoreContent();
            }
        });
    }
});
